import React, { ReactNode } from 'react';
import styles from './assets/provider-list-screen.module.scss';
import classNames from 'classnames';
import ProvidersGrid from './components/ProvidersGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import CreateProviderButton from './components/CreateProviderButton';
import AdminLayout from 'src/components/layout/RoleLayout';
import { IProvider } from 'src/types/provider';
import user from '../../../../../../services/user-auth';
import UserRole from '../../../../../../enumerables/user-role';
import Loader from '../../../../../../components/Loader';

export interface StateProps {
    data: Paginated<Partial<IProvider>>;
    inProgress: boolean;
    serviceTypes: { [key: string]: string };
    serviceLocations: { [key: string]: string };
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getServiceTypes: (params: QueryParams) => void;
    getServiceLocations: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class ProviderListScreen extends React.Component<Props> {
    componentDidMount() {
        this.props.getServiceTypes({
            page: 1,
            itemsPerPage: 1200,
        });
        this.props.getServiceLocations({
            page: 1,
            itemsPerPage: 1200,
        });
    }

    public render(): ReactNode {
        const { data, getData, inProgress } = this.props;
        return (
            <AdminLayout>
                <div className={`${classNames(styles.pageHeading)} ${'pageHeading'}`}>
                    <h2 className={`${classNames(styles.pageHeadingTitle)} ${'pageHeadingTitle'}`}>
                        PROVIDERS {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                    {user.getRoles().includes(UserRole.ROLE_ADMIN) ? <CreateProviderButton /> : null}
                </div>
                {inProgress ? <Loader /> : null}
                <div className={classNames(styles.list)}>
                    <ProvidersGrid data={data} getData={getData} />
                </div>
            </AdminLayout>
        );
    }
}

export default ProviderListScreen;
